import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

const KEY = "sq_ref";
const TTL = 30 * 86400000;

function readRef() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && /^[A-Z0-9]{4,16}$/.test(v.code) && Date.now() - v.ts < TTL ? v.code : null;
  } catch { return null; }
}

export function RefCapture() {
  const { search } = useLocation();
  useEffect(() => {
    const code = new URLSearchParams(search).get("ref");
    if (code && /^[A-Za-z0-9]{4,16}$/.test(code)) localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), ts: Date.now() }));
  }, [search]);
  return null;
}

export function useAttachReferral() {
  useEffect(() => {
    const code = readRef();
    localStorage.removeItem(KEY);
    if (!code) return;
    api.post("/referral/attach", { code })
      .then(() => toast.success("Invito registrato: hai il 50% di sconto sul primo mese di Pro"))
      .catch(() => {});
  }, []);
}
